import { useEffect, useState } from 'react';
import { useAuth, useAuthActions } from '../state/AuthContext';
import '../styles/action-pills-callout.css';

// Number of artist detail panels a signed-in user can open before we
// surface the action-pills nudge — gives them a few opportunities to
// discover the pills on their own before interrupting them.
const PANEL_OPENS_BEFORE_NUDGE = 3;

// Once-per-account nudge that highlights the Favorite / Neutral / Dislike
// pills if the user has opened several artist detail panels without
// marking any artist. We never show it to users who've already started
// marking on their own.
function ActionPillsCallout() {
  const { user, favorites, dislikes, knownArtists, discoveredArtists } = useAuth();
  const { setActionPillsCalloutShown } = useAuthActions();
  const [show, setShow] = useState(false);

  const hasMarks =
    favorites.length + dislikes.length + knownArtists.length + discoveredArtists.length > 0;
  const panelsOpened = user?.artistPanelsOpened || 0;

  useEffect(() => {
    // Once we've decided to render, lock it in until the user dismisses —
    // don't re-evaluate when flipping the "shown" flag below.
    if (show) return;
    if (!user) return;
    if (user.actionPillsCalloutShown) return;
    if (hasMarks) return;
    if (panelsOpened < PANEL_OPENS_BEFORE_NUDGE) return;

    setShow(true);
    // Persist immediately so subsequent panel opens (and other devices)
    // never re-surface the nudge.
    setActionPillsCalloutShown();
  }, [user, hasMarks, panelsOpened, show, setActionPillsCalloutShown]);

  if (!show) return null;

  return (
    <div className="action-pills-callout" role="note">
      <button
        className="action-pills-callout-close"
        onClick={() => setShow(false)}
        aria-label="Dismiss"
      >
        &times;
      </button>
      <div className="action-pills-callout-title">Rate to build your universe</div>
      <div className="action-pills-callout-text">
        Tap <strong>Favorite</strong> for artists you love, <strong>Neutral</strong> for
        ones you know, or <strong>Dislike</strong> to filter them out.
      </div>
    </div>
  );
}

export default ActionPillsCallout;
